import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Transition } from 'react-transition-group';
import { FormattedMessage } from 'react-intl';

// Components
import ToggleArrow from '../../ToggleArrow';

// Icons
import CheeseBorderIcon from '../../../icons/cheese-border.svg';
import CheckIcon from '../../../icons/check.svg';

// Assets
import stuffedCrustNone from './assets/stuffedCrustNone.png';
import stuffedCrustCheese from './assets/stuffedCrustCheese.png';
import stuffedCrustSausage from './assets/stuffedCrustSausage.png';

// Styles
import styles from './BorderToggle.styl';

const cx = classNames.bind(styles);

const stuffedCrustImages = {
  none: stuffedCrustNone,
  cheese: stuffedCrustCheese,
  sausage: stuffedCrustSausage,
};

export default function CheeseBorderToggle(props) {
  const { selectStuffedCrust, stuffedCrustsAvailable, className, activeStuffedCrust } = props;

  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  const onClick = value => {
    selectStuffedCrust(value);
  };

  const onBlur = () => {
    if (isOpen) {
      setIsOpen(false);
    }
  };

  return (
    <div className={cx('BorderToggle', className)} onBlur={onBlur}>
      <div
        className={cx(`BorderToggle__toggle`, {
          BorderToggle__toggle_active: activeStuffedCrust !== 'none',
        })}
        onClick={toggle}
        onKeyDown={e => e.key === 'Enter' && toggle()}
        role="button"
        tabIndex={0}
      >
        <CheeseBorderIcon width={43} height={21} />
        <ToggleArrow className={cx('BorderToggle__toggle-arrow')} isOpen={isOpen} />
      </div>
      <Transition in={isOpen} timeout={{ enter: 0, exit: 175 }} mountOnEnter unmountOnExit>
        {state => (
          <div className={cx('BorderToggle__body', `BorderToggle__body_${state}`)}>
            {stuffedCrustsAvailable.map(type => (
              <button
                key={type}
                className={cx('BorderToggle__item', {
                  BorderToggle__item_active: activeStuffedCrust === type,
                })}
                name={type}
                type="button"
                onClick={() => onClick(type)}
              >
                <img
                  className={cx('BorderToggle__img')}
                  src={stuffedCrustImages[type]}
                  alt="stuffedCrust"
                />
                <div className={cx('BorderToggle__text')}>
                  <FormattedMessage id={`pizza.stuffedCrust.${type}`} />
                </div>
                <div className={cx('BorderToggle__icon-wrapper')}>
                  <CheckIcon className={cx('BorderToggle__icon')} />
                </div>
              </button>
            ))}
          </div>
        )}
      </Transition>
    </div>
  );
}

CheeseBorderToggle.defaultProps = {
  className: '',
  stuffedCrustsAvailable: [],
};

CheeseBorderToggle.propTypes = {
  className: PropTypes.string,
  stuffedCrustsAvailable: PropTypes.array,
  activeStuffedCrust: PropTypes.string.isRequired,
  selectStuffedCrust: PropTypes.func.isRequired,
};
